import React from 'react'

function Footer() {
  return (<footer><span>© </span> 2025 <a href="https://simonaking.com/" target="blank">SimonAKing</a></footer>)
}

export default Footer
